// extracted by mini-css-extract-plugin
module.exports = {"loadingBase":"#3FBFE7"};